import BaseModel from '../core/BaseModel'
export default class CustomerLogChangeModel extends BaseModel {

    constructor() {
        super({ 
                name: "customer_log_changed",
                tableName: 'core_customer_profile_log_changed', 
                label: "Quản lý khách hàng"
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                class: 'center',
                sortable: true,
                width: 13,
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                class: 'center',
                sortable: true,
                computed: (data) => {
                    data.full_name = (data.users !== undefined && data.users !== null) ? data.users.full_name  :  '';
                }
            },
            organization: { 
                name: 'organization', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                sortable: true,
                computed: (data) => {
                    data.organization = (data.users !== undefined && data.users !== null && data.users.organization_account != null && data.users.organization_account.organization != null) ? data.users.organization_account.organization.name  :  '';
                }
            },
            detail: { 
                name: 'detail', 
                type: "Text", 
                label: 'Chi tiết',
                class: 'center',
                callback: true,
                width: 20,
                computed: (data) => {
                    data.detail = '<abbr class="external-link">Xem chi tiết</abbr>';
                }
            },
            modifier_id: {
                refs: 'users { full_name organization_account { organization { name } } } new_value',
                display: false
            }
        },)
    }

}